import React from "react";
import { Col, Offcanvas } from "react-bootstrap";
import { Input } from "shared/ui-basics";
import styled, { css } from "styled-components/macro";

export const SideModal = styled(Offcanvas)`
	min-width: 800px;
	box-shadow: -2px 0px 4px 0px rgba(0, 0, 0, 0.25);
	padding: 16px;
	overflow: auto;
	.btn-close:focus {
		box-shadow: none !important;
	}
`;

interface FlexAlignProps extends React.HTMLAttributes<HTMLDivElement> {
	gap?: number;
	justifyContent?: string;
	focus?: boolean;
}

export const FlexContainer = styled.div<FlexAlignProps>`
	display: flex;
	align-items: center;
	gap: ${({ gap }) => gap || 0}px;

	justify-content: ${({ justifyContent }) => justifyContent || "flex-start"};
	${({ focus }) =>
		focus &&
		css`
			&:focus-within {
				border: 1px solid var(--color-Grey-Primary-Text, #333333);
				box-shadow: none;
				border-radius: 4px;
			}
		`}
`;

export const FlexBetween = styled.div<React.HTMLAttributes<HTMLDivElement>>`
	display: flex;
	justify-content: space-between;
	align-items: center;
`;
interface TitleInputProps extends React.HTMLAttributes<HTMLDivElement> {
	fontSize?: string | number;
	fontWeight?: number | string;
	color?: number | string;
	noborder?: boolean;
}

export const TitleInput = styled(Input)<TitleInputProps>`
	color: ${({ color }) => color || "#333333"};
	font-family: "Inter";
	font-size: ${({ fontSize }) => fontSize || "14px"};
	font-style: normal;
	font-weight: ${({ fontWeight }) => fontWeight || "normal"};
	line-height: 27px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	border: none;
	outline: none;

	&:focus {
		border: 1px solid #333333;
		box-shadow: none;
		${({ noborder }) =>
			noborder === 'true' &&
			css`
				border: none;
			`}
	}
`;
interface RegularTextProps extends React.HTMLAttributes<HTMLDivElement> {
	fontSize?: string | number;
	fontWeight?: number | string;
	color?: string;
}
export const RegularText = styled.div<RegularTextProps>`
	font-family: Inter;
	font-size: ${({ fontSize }) => fontSize || "14px"};
	font-style: normal;
	font-weight: ${({ fontWeight }) => fontWeight || "normal"};
	line-height: 25px;
	color: ${({ color }) => color || "var(--color-Grey-Primary-Text, #333333)"};
`;
interface labelProps extends React.HTMLAttributes<HTMLDivElement> {
	size?: string | number;
	fs?: number | string;
	fw?: string;
}
export const Label_ts = styled.div<labelProps>`
	color: ${(props) => (props.color ? props.color : "#605f60")};
	font-family: "Inter";
	font-size: ${({ size }) => size}px;
	font-style: ${({ fs }) => (fs ? fs : "normal")};
	font-weight: ${({ fw }) => (fw ? fw : 400)};
`;
export const StyledCol = styled(Col)`
display: flex;
align-items: center;
gap: 8px;
height:48px;
 #eyeButton {
    visibility: hidden;
 }
:hover {
        #eyeButton {
            visibility: visible;
        }
    }
`

export const IconWrapper = styled.div`
	width: 38px;
	min-width: 38px;
	height: 38px;
	border-radius: 50%;
	border: 1px solid #000000;
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const NoData = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 23px;
	min-height: 130px;
`;

export const NoDataIcon = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const NoDataText = styled.div`
	color: #605f60;
	text-align: center;
	font-family: "Inter";
	font-size: 0.875rem;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
`;
